import * as styles from "./OrderPosition.style.ts";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { H4, H6 } from "src/components/HeadingV2/HeadingV2.tsx";
import { Counter } from "src/components/Counter/Counter.tsx";
import { formatPrice } from "@exonn/utils";
import { Currency } from "src/common/constants.ts";

import placeholderImage from "src/assets/illustrations/placeholder_image.svg";
import type { ExonnHubCartItem } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.types.ts";

import { Trans, useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useExonnHubContext } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubContext.ts";
import { useAddProductToOrder } from "src/admin/modules/b2b-gate-order/components/EditSupplierOrderForB2bGate/hooks/useAddProductToCart.ts";

export const OrderPosition = ({ cartItem }: { cartItem: ExonnHubCartItem }) => {
  const totalFormatted = formatPrice(cartItem.total ?? 0, Currency.EUR);
  const { amountPerPackage, quantityInPackages } = cartItem;
  const { orderId } = useExonnHubContext();
  const { mutate: updateProductInOrder } = useAddProductToOrder();
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);

  return (
    <div css={styles.root}>
      <div css={styles.imageColumn}>
        <div>
          <TextV2 css={styles.productNumber} variant={"body2"}>
            Prod. Nr: {cartItem.sku}
          </TextV2>
        </div>
        <div
          css={styles.image({
            src: cartItem.small_image || placeholderImage,
          })}
        />
      </div>
      <div css={styles.titleColumn}>
        <H6>{cartItem.title}</H6>
        <TextV2 variant={"body1"}> {cartItem.supplierName}</TextV2>
      </div>
      <div css={styles.counterColumn}>
        <div css={styles.counter}>
          <Counter
            // todo: disallow adding more quantity than there is in stock
            count={quantityInPackages}
            onDelete={() => {
              updateProductInOrder({
                data: {
                  b2b_gate_order_id: orderId,
                  quantity_ordered: 0,
                  variant_id: cartItem.variantId,
                  unit_price: cartItem.unitPrice,
                },
                locale: "de",
              });
            }}
            onChange={(count) => {
              updateProductInOrder({
                data: {
                  b2b_gate_order_id: orderId,
                  quantity_ordered: count * amountPerPackage,
                  variant_id: cartItem.variantId,
                  unit_price: cartItem.unitPrice,
                },
                locale: "de",
              });
            }}
          />
        </div>
        {quantityInPackages && (
          <div css={styles.totalWrapper}>
            <TextV2 variant={"body2"} css={styles.totalExplanation}>
              <Trans
                i18nKey="totalExplanation"
                t={t}
                values={{
                  packages: quantityInPackages,
                  units: quantityInPackages * amountPerPackage,
                }}
              />
            </TextV2>
            <H4 css={styles.total}>{totalFormatted}</H4>
          </div>
        )}
      </div>
    </div>
  );
};
